import { AssignmentInd, Close } from "@mui/icons-material"
import { Autocomplete, Button, Chip, CircularProgress, FormControl, Grid2, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material"
import { Dispatch, memo, SetStateAction, useCallback, useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { IBranch, IUser } from "sierra"
import api from "../../../utils/axios"
import socket from "../../../utils/socket"
import { useApp } from "../../../contexts/AppContext"

const AssignManagers = memo(({ setOpenAssignManagers }: { setOpenAssignManagers: Dispatch<SetStateAction<boolean>> }) => {

    const location = useLocation()
    const navigate = useNavigate()
    const {translate} = useApp()

    const branch: IBranch = useMemo(() => location.state?.branch, [location])

    const [managers, setManagers] = useState<IUser[]>()
    const [selectedManagers, setSelectedManagers] = useState<number[]>(branch?.branch_managers || [])
    const [apiCall, setApiCall] = useState<boolean>(false)

    // const handleAddToManagers = useCallback((e: SelectChangeEvent) => {
    //     if (!selectedManagers.includes(parseInt(e.target.value as string))) setSelectedManagers(prev => [...prev, parseInt(e.target.value as string)])
    // }
    //     , [selectedManagers])

    // const handleDeleteFromManagers = useCallback((e: number) => setSelectedManagers(prev => prev.filter(p => e !== p))
    //     , [])

    const handleManagerChange = (_event: any, newValue: IUser[]) => {
        setSelectedManagers(newValue.map((manager) => manager.user_id));
    };

    const handleAssignManagers = useCallback(() => {
        setApiCall(true)
        api.patch(`/branches/${branch.branch_id}/assignManagers`, { managers: selectedManagers }, { meta: { showSnackbar: true } }).then(() => {
            setApiCall(false)
        }).catch(() => {
            console.error
            setApiCall(false)
        })
    }
        , [branch, selectedManagers])


    const fetchManagers = useCallback(() => api.get('/managers').then(res => setManagers(res.data)).catch(console.error), [])

    useEffect(() => {
        fetchManagers()
        socket.on("managers_branches_changed", fetchManagers);
        return () => {
            socket.off("managers_branches_changed", fetchManagers);
        }
    }, [])
    useEffect(() => {
        console.log(selectedManagers);
        console.log(branch.branch_managers);
        console.log(selectedManagers.every((e, i) => e === branch.branch_managers[i]));
    }, [selectedManagers])

    useEffect(() => {
        setSelectedManagers(branch?.branch_managers || [])
    }, [location])

    return (
        <Grid2 container padding={2} spacing={4} flexDirection={'column'}>
            <Grid2 container size={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>

                <Grid2>
                    <Typography variant='h5'>
                        {translate("Assign Managers")}
                    </Typography>
                </Grid2>

                <Grid2>
                    <IconButton onClick={() => setOpenAssignManagers(false)}>
                        <Close />
                    </IconButton>
                </Grid2>

            </Grid2>


            {!managers ? <CircularProgress /> : managers.length == 0 ?
                <Grid2 container flexDirection={'column'}>
                    <Grid2>
                        <Typography>{translate("No managers, please invite managers.")}</Typography>
                    </Grid2>
                    <Grid2>
                        <Button fullWidth variant="contained" onClick={() => navigate('/system/users/invite')}>{translate("Invite Managers")}</Button>
                    </Grid2>
                </Grid2>
                :
                <Grid2 container size={'grow'} flexDirection={'column'} spacing={4}>
                    <Grid2>
                        <Autocomplete
                            multiple
                            onChange={handleManagerChange}
                            options={managers}
                            getOptionLabel={(option) => option.name}
                            value={managers.filter(m => selectedManagers.includes(m.user_id))}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="standard"
                                    label={translate("Select Managers")}
                                />
                            )}
                        />
                    </Grid2>

                    {/* <Grid2>
                        <FormControl fullWidth>
                            <InputLabel shrink={false}>Select a manager.</InputLabel>
                            <Select
                                value={''}
                                label="Select a Manager"
                                onChange={handleAddToManagers}
                                variant="filled"
                            >
                                {managers.map((m, i) => <MenuItem key={i} value={m.user_id}>{m.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid2>
                    <Grid2 container display={'flex'} alignItems={'center'} spacing={1} padding={2} sx={{ border: t => `1px solid ${t.palette.primary.main}` }}>
                        <Grid2>
                            <Typography>Assigned Managers: </Typography>
                        </Grid2>
                        {
                            selectedManagers.length == 0 ?
                                <Typography color="error">No managers assigned. Please select a manager.</Typography> :
                                selectedManagers.map((sm, i) => managers.map(m => m.user_id == sm && <Grid2><Chip key={i} label={m.name} onDelete={() => handleDeleteFromManagers(sm)}></Chip></Grid2>))
                        }
                    </Grid2> */}
                    <Grid2>
                        <Button variant="contained" fullWidth onClick={handleAssignManagers}
                            disabled={apiCall || selectedManagers === branch.branch_managers}
                            endIcon={apiCall ? <CircularProgress /> : <AssignmentInd />}>
                            {translate("Assign Managers")}
                        </Button>
                    </Grid2>
                </Grid2>
            }


        </Grid2>
    )
})

export default AssignManagers
